<template>
  <div class="navbar">
    <div class="navbar-content">
      <div class="navbar-left">
        <h1 class="navbar-title">
          <el-icon><Monitor /></el-icon>
          {{ $t('admin.title') }}
        </h1>
      </div>
      
      <div class="navbar-right">
        <!-- 语言切换器 -->
        <el-dropdown @command="handleLanguageChange" trigger="click">
          <span class="language-switcher">
            <el-icon><Globe /></el-icon>
            {{ getCurrentLanguageName() }}
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="zh">🇨🇳 {{ $t('admin.chinese') }}</el-dropdown-item>
              <el-dropdown-item command="en">🇺🇸 {{ $t('admin.english') }}</el-dropdown-item>
              <el-dropdown-item command="es">🇪🇸 {{ $t('admin.spanish') }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        
        <!-- 用户菜单 -->
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="user-dropdown">
            <el-avatar :size="32" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />
            <span class="user-name">{{ userName }}</span>
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">
                <el-icon><SwitchButton /></el-icon>
                {{ $t('admin.logout') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'NavbarComponent',
  setup() {
    const { t, locale } = useI18n()
    const store = useStore()
    const router = useRouter()
    
    const userName = computed(() => store.state.user.name || t('admin.defaultUserName'))
    
    const getCurrentLanguageName = () => {
      const languageMap = {
        'zh': t('admin.chinese'),
        'en': t('admin.english'),
        'es': t('admin.spanish')
      }
      return languageMap[locale.value] || t('admin.chinese')
    }
    
    const handleLanguageChange = (command) => {
      locale.value = command
      store.dispatch('app/setLanguage', command)
      document.title = t('admin.title')
      ElMessage.success(t('common.success'))
    }
    
    const handleCommand = (command) => {
      if (command === 'logout') {
        store.dispatch('user/logout').then(() => {
          router.push('/login')
        })
      }
    }
    
    return {
      userName,
      getCurrentLanguageName,
      handleLanguageChange,
      handleCommand
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #304156;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  
  .navbar-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 20px;
    
    .navbar-left {
      position: absolute;
      left: 20px;
      z-index: 1001;
      
      .navbar-title {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        
        .el-icon {
          color: #409eff;
        }
      }
    }
    
    .navbar-right {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-left: auto;
      
      .language-switcher,
      .user-dropdown {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 4px;
        transition: background-color 0.3s;
        color: #bfcbd9;
        
        &:hover {
          background-color: #263445;
          color: #fff;
        }
        
        .el-icon {
          color: #bfcbd9;
        }
        
        &:hover .el-icon {
          color: #fff;
        }
      }
      
      .user-name {
        font-size: 14px;
        color: #bfcbd9;
      }
    }
  }
}
</style>
